// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f2a7d5e1","517":"8e7ae596","659":"6e240051"}[chunkId] + ".chunk.js";
};